import React from 'react';
import { Wrapper, Container } from './style';
import { getNoToken } from '../../utils/request';
import { Toast,DatePicker,List } from 'antd-mobile';
import Config from '../../config';
import moment from 'moment';
import bg_07 from '../../assets/images/bg_07.png';

class PregnCalculat2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      height: 0,
      cardTop: 0,
      newTime1: '', //妊娠开始
      active1: false,
      newTime2: '', //妊娠中期
      active2: false,
      newTime3: '', //妊娠晚期
      active3: false,
      newTime4: '', //预产期
      active4: false,
      nowTime: '', //当前日期
      isShowCard: false,
      isShowJin: false,

      hasDays: '', // 怀孕天数
      hasWeek: '',
      toSheDays: '', // 距离生产天数
      toWeek: '',
    }
  }
  async componentDidMount() {
    document.title = '水母来了-孕周计算器'
    document.getElementsByTagName('html')[0].style.background = '#f4f4f4'
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
    let index = this.props.match.params.index
    let oldTime = this.props.match.params.time
    let array = [0, 92, 197, 279]
    let newTime1 = this.dateChange(array[0], oldTime)
    let newTime2 = this.dateChange(array[1], oldTime)
    let newTime3 = this.dateChange(array[2], oldTime)
    let newTime4 = this.dateChange(array[3], oldTime)
    let nowTime = moment(new Date()).format('YYYY-MM-DD')
    let hasDays = this.dateMinus(nowTime, oldTime)
    let hasWeek = `${parseInt(hasDays/7)}周${hasDays-(parseInt(hasDays/7)*7)}天`
    if(hasDays>0&&hasDays<=280){
      this.setState({isShowJin: true})
    } else {
      // if(hasDays<=0){
      //   Toast.info('当前日期不在孕期期间哦')
      // }
      Toast.info('当前日期不在孕期期间哦')
    }
    //let toSheDays = this.dateMinus(newTime4, nowTime)
    let toSheDays = 280 - hasDays
    let toSheWeek = `${parseInt(toSheDays/7)}周${toSheDays-(parseInt(toSheDays/7)*7)}天`
    this.setState({newTime1,newTime2,newTime3,newTime4,nowTime,hasDays,toSheDays,hasWeek,toSheWeek})
    let height = Math.round((730/280)*hasDays)
    height = height>=730?730:height
    let cardTop = height>=540?540:height
    setTimeout(() => {
      this.setState({height,cardTop})
    }, 100)
    if(hasDays>=280){
      this.setState({active4: true,active3: true,active2: true,active1: true})
    }
    if(hasDays>=197){
      this.setState({active3: true,active2: true,active1: true})
    }
    if(hasDays>=92){
      this.setState({active2: true,active1: true})
    }
    if(hasDays>=0){
      this.setState({active1: true})
    }
    setTimeout(() => {
      if(hasDays>0&&hasDays<=280){
        this.setState({isShowCard: true})
      }
    }, 2000)

    let res = await this.loadWxConfig();
    if(res.data.code == 100){
      window.wx.config({
        debug: false,
        ...res.data.data,
        jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateTimelineShareData','updateAppMessageShareData']
      });
    } else {
      Toast.info('配置微信分享异常')
    }
    window.wx.ready(() => {
      //分享朋友圈
      window.wx.onMenuShareTimeline({
        title: '水母来了-孕周计算器，孕期状态早知道',
        link: `${Config.HTTP_HOST_SMLL}/pregnCalculat1?ts=${Date.parse(new Date())}`,
        imgUrl: 'http://img.bangivf.com/images/yunzhoujisuanqi.png',
        success: res => {},
        cancel: err => {}
      })
      //分享给朋友
      window.wx.onMenuShareAppMessage({
        title: '水母来了-孕周计算器，孕期状态早知道',
        desc: '方便快捷完成您的预产期计算，提早为宝宝降临做准备',
        link: `${Config.HTTP_HOST_SMLL}/pregnCalculat1?ts=${Date.parse(new Date())}`,
        imgUrl: 'http://img.bangivf.com/images/yunzhoujisuanqi.png',
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: res => {},
        cancel: err => {}
      })
      //分享朋友圈
      window.wx.updateTimelineShareData({
        title: '水母来了-孕周计算器，孕期状态早知道',
        link: `${Config.HTTP_HOST_SMLL}/pregnCalculat1?ts=${Date.parse(new Date())}`,
        imgUrl: 'http://img.bangivf.com/images/yunzhoujisuanqi.png',
        success: res => {},
        cancel: err => {}
      })
      //分享给朋友
      window.wx.updateAppMessageShareData({
        title: '水母来了-孕周计算器，孕期状态早知道',
        desc: '方便快捷完成您的预产期计算，提早为宝宝降临做准备',
        link: `${Config.HTTP_HOST_SMLL}/pregnCalculat1?ts=${Date.parse(new Date())}`,
        imgUrl: 'http://img.bangivf.com/images/yunzhoujisuanqi.png',
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: res => {},
        cancel: err => {}
      })
    })
  }
  dateChange(num,date){
    if (!date){
      date = new Date();//没有传入值时,默认是当前日期
      date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }
    //date += " 00:00:00";//设置为当天凌晨12点
    date = Date.parse(new Date(date))/1000;//转换为时间戳
    date += (86400) * num;//修改后的时间戳
    var newDate = new Date(parseInt(date) * 1000);//转换为时间
    //return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
    return moment(newDate).format('YYYY-MM-DD')
  }
  dateMinus(startTime, endTime) {
    var start = new Date(startTime); 
    var end = new Date(endTime); 
    var days = start.getTime() - end.getTime();
    var day = Math.floor(days / (1000 * 60 * 60 * 24));
    return day +1;
  }
  async loadWxConfig(){
    let appid = Config.appId
    let url = window.location.href.split('#')[0]
    let params = {appid, url}
    let res = await getNoToken(`/pgy/user/${Config.appId}/jsapiTicket`, params)
    return res
  }
  render() {
    let { 
      height,isShowCard,nowTime,cardTop,hasDays,toSheDays,hasWeek,toSheWeek,isShowJin,
      newTime1,newTime2,newTime3,newTime4,active1,active2,active3,active4
    } = this.state;
    return (
      <Wrapper>
        <Container>
          <div className="banner">
            <p>预产期</p>
            <span>{newTime4}</span>
          </div>
          <div className="main">
            <div className="center">
              <div className="content">
                <div className="times">
                  <div>
                    <p>妊娠开始</p>
                    <span>{newTime1}</span>
                  </div>
                  <div>
                    <p>妊娠中期</p>
                    <span>{newTime2}</span>
                  </div>
                  <div>
                    <p>妊娠晚期</p>
                    <span>{newTime3}</span>
                  </div>
                  <div>
                    <p>预产期</p>
                    <span>{newTime4}</span>
                  </div>
                </div>
                <div className="under">
                  <div className="def"></div>
                  <div className="os">
                    <p><span className={active1?'active':''}></span></p>
                    <p><span className={active2?'active':''}></span></p>
                    <p><span className={active3?'active':''}></span></p>
                    <p><span className={active4?'active':''}></span></p>
                  </div>
                  {active1&&(
                    <div className="on">
                      <p style={{height:`${height/100}rem`}}></p>
                      {isShowJin&&(<b>今</b>)}
                    </div>
                  )}
                </div>
                <div className="msg">
                  <div className={`card ${isShowCard?'active':''}`} style={{top:`${cardTop/100}rem`}}>
                    <div>{nowTime}</div>
                    <p>您已怀孕<span>{hasDays}天({hasWeek})</span></p>
                    <b>距离预产期还有<span>{toSheDays}天({toSheWeek})</span></b>
                  </div>
                </div>
              </div>
              <div className="title">温馨提示：预产期仅供参考，推测与实际结果可能有一定差值，最终以产检结果为准。</div>
            </div>
          </div>
        </Container>
      </Wrapper>
    );
  }
}
export default PregnCalculat2;